import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/quickbooks/{creatorId}/status';

export type QuickBooksStatusApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

/**
 * Hook to fetch QuickBooks connection status for a creator.
 * Revalidates on focus by default to ensure status is current when user returns to tab.
 */
export const useQuickBooksStatus = (
  params: QuickBooksStatusApi['params'] | null,
  config?: UseNoodleSwrConfig<QuickBooksStatusApi['response']>,
): SWRResponse<QuickBooksStatusApi['response'], ApiError> => {
  const path = params ? buildPath<QuickBooksStatusApi>(PATH_TEMPLATE, params) : null;
  return useNoodleSwr(path, config);
};
